// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Cosmic Loans Page Styles
   ========================================== */

.loans-page {
  min-height: 100vh;
  padding: 8rem 0 4rem;
}

.loans-header {
  text-align: center;
  margin-bottom: 3rem;
}

.loan-types {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  margin-bottom: 2rem;
}

.loan-type-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-bento-small);
  background: rgba(0, 0, 0, 0.2);
  color: var(--text-muted);
  min-width: 140px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
}

.loan-type-card:hover, .loan-type-card.active {
  border-color: var(--color-neon-purple);
  background: rgba(176, 38, 255, 0.1);
  color: #ffffff;
  transform: translateY(-2px);
}

.loan-icon {
  font-size: 2.5rem;
  margin-bottom: 0.75rem;
}

.loan-type-card h3 {
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}

.loan-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-bento-small);
}

.feature-value {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--color-neon-cyan);
}

.feature-label {
  font-size: 0.85rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.25rem;
}

.calc-toggle-btn {
  background: none;
  border: none;
  color: var(--color-neon-purple);
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  text-decoration: underline;
}

.calculator {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(176, 38, 255, 0.2);
  padding: 2rem;
  border-radius: var(--radius-bento-inner);
  margin-bottom: 2rem;
}

.calc-section {
  margin-bottom: 1.5rem;
}

.calc-section label {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: block;
}

.slider-container input[type="range"] {
  width: 100%;
  accent-color: var(--color-neon-cyan);
  padding: 0;
  background: transparent;
  border: none;
}

.slider-value {
  color: var(--color-neon-cyan);
  font-weight: 700;
  font-size: 1.1rem;
  margin-top: 0.5rem;
  display: block;
}

.calc-result {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.monthly-payment {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.monthly-payment .label {
  color: var(--text-muted);
  font-weight: 600;
}

.monthly-payment .value {
  font-size: 2rem;
  font-weight: 800;
  background: var(--grad-cosmic);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.application-form {
  margin-top: 2rem;
}

.form-section {
  margin-bottom: 1.25rem;
}

.form-section label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.loan-benefits ul {
  list-style: none;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

.loan-benefits li {
  color: var(--text-muted);
  padding: 0.5rem 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.loan-benefits li::before {
  content: '\\2728';
  font-size: 1.2rem;
}

.testimonial {
  background: rgba(0, 0, 0, 0.3);
  padding: 1.5rem;
  border-radius: var(--radius-bento-small);
  border-left: 3px solid var(--color-neon-purple);
}

.testimonial p {
  color: #e2e8f0;
  font-style: italic;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.testimonial-author .name {
  font-weight: 700;
  color: #ffffff;
  display: block;
}

.testimonial-author .title {
  color: var(--text-muted);
  font-size: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Loans.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,wCAAwC;EACxC,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":["/* ==========================================\n   Kubersetu Cosmic Loans Page Styles\n   ========================================== */\n\n.loans-page {\n  min-height: 100vh;\n  padding: 8rem 0 4rem;\n}\n\n.loans-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.loan-types {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto;\n  margin-bottom: 2rem;\n}\n\n.loan-type-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1.5rem;\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-bento-small);\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--text-muted);\n  min-width: 140px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n}\n\n.loan-type-card:hover, .loan-type-card.active {\n  border-color: var(--color-neon-purple);\n  background: rgba(176, 38, 255, 0.1);\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.loan-icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.loan-type-card h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.loan-features {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.feature {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-bento-small);\n}\n\n.feature-value {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--color-neon-cyan);\n}\n\n.feature-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-top: 0.25rem;\n}\n\n.calc-toggle-btn {\n  background: none;\n  border: none;\n  color: var(--color-neon-purple);\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 1.5rem;\n  font-size: 1rem;\n  text-decoration: underline;\n}\n\n.calculator {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(176, 38, 255, 0.2);\n  padding: 2rem;\n  border-radius: var(--radius-bento-inner);\n  margin-bottom: 2rem;\n}\n\n.calc-section {\n  margin-bottom: 1.5rem;\n}\n\n.calc-section label {\n  color: #ffffff;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  display: block;\n}\n\n.slider-container input[type=\"range\"] {\n  width: 100%;\n  accent-color: var(--color-neon-cyan);\n  padding: 0;\n  background: transparent;\n  border: none;\n}\n\n.slider-value {\n  color: var(--color-neon-cyan);\n  font-weight: 700;\n  font-size: 1.1rem;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.calc-result {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.monthly-payment {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.monthly-payment .label {\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.monthly-payment .value {\n  font-size: 2rem;\n  font-weight: 800;\n  background: var(--grad-cosmic);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.application-form {\n  margin-top: 2rem;\n}\n\n.form-section {\n  margin-bottom: 1.25rem;\n}\n\n.form-section label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.loan-benefits ul {\n  list-style: none;\n  margin-top: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.loan-benefits li {\n  color: var(--text-muted);\n  padding: 0.5rem 0;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.loan-benefits li::before {\n  content: '\\2728';\n  font-size: 1.2rem;\n}\n\n.testimonial {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 1.5rem;\n  border-radius: var(--radius-bento-small);\n  border-left: 3px solid var(--color-neon-purple);\n}\n\n.testimonial p {\n  color: #e2e8f0;\n  font-style: italic;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.testimonial-author .name {\n  font-weight: 700;\n  color: #ffffff;\n  display: block;\n}\n\n.testimonial-author .title {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
